import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ResultPage from './pages/ResultPage';

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<LoginPage />} />
                <Route path = "/result" element={<ResultPage/>} />
                <Route path="*" element={<LoginPage />} />
            </Routes>
        </BrowserRouter>
    )
}

export default App;